export class LocaleUpdater<T extends { survey_localization: string }> {
  constructor(
    private readonly _currentList: T[],
    private readonly _upComing: T
  ) {}

  public update(): T[] {
    return [
      ...this._currentList.filter(
        (current) =>
          current.survey_localization !== this._upComing.survey_localization
      ),
      this._upComing,
    ];
  }
}
